<template>

<Panel class="panel-border">
  <PanelHeading>
      <div slot="title">

        <!-- edit mode -->
        <form style="max-width: 250px;" v-if="editingTitle" v-on:submit.prevent="finishEditingTitle">
          <div class="input-group input-group-sm">
            <input
              v-model="newTitle"
              v-focus
              v-on:keyup.esc="cancelEditingTitle"
              v-on-click-away="cancelEditingTitle"
              type="text"
              class="form-control input-sm">
            <span class="input-group-btn">
              <button type="submit" class="btn btn-primary">Save</button>
            </span>
          </div>
        </form><!-- end if editing -->

        <!-- Non-edit mode -->
        <div v-else>
          <span v-on:dblclick="startEditingTitle">{{subject.title}}</span>
          <span v-on:click="toggleExpanded" class="expandButton">
            <span v-if="expanded" class="icon mdi mdi-chevron-down"></span>
            <span v-else class="icon mdi mdi-chevron-right"></span>
          </span>

          <span class="panel-subtitle">{{`${chapters.length} Chapter${chapters.length === 1 ? '' : 's'}`}}</span>
        </div>

      </div>

    </PanelHeading>

  <PanelBody v-if="expanded">


    <div v-if=" !chapters.length">
      <p><em>This subject is empty.</em></p>
      <p v-if="showActions"><a @click.prevent="deleteSubject(subject)" href>Delete subject</a></p>
    </div>

    <div v-else>
      <table class="table">
        <thead>
          <tr>
            <th style="width:5%;" class="hidden-xs">
              <!--                       <div class="be-checkbox be-checkbox-sm">
                        <input id="check1" type="checkbox">
                        <label for="check1"></label>
                      </div> -->
            </th>
            <th style="width:25%;">Chapter</th>
            <th style="width:20%;">Study Progress</th>
            <th style="width:10%" class="hidden-xs">&nbsp;</th>
            <th style="width:10%;" class="hidden-xs">Last Studied</th>
            <th style="width:20%;"></th>
            <!-- <th style="width:10%">&nbsp;</th> -->
          </tr>
        </thead>
        <tbody>

          <SubjectShelfChapterRow v-for="chapter in chapters" :chapter="chapter" />

        </tbody>
      </table>
    </div>
  </PanelBody>

</Panel>

</template>

<script>
import _ from 'underscore'
import { mapState, mapActions } from 'vuex';
import SubjectShelfChapterRow from './SubjectShelfChapterRow';
import { directive as onClickAway } from 'vue-clickaway'

export default {
  props: ['subject'],

  components: {
    SubjectShelfChapterRow,
  },

  methods: {
    deleteSubject(subject) {
      // if( !confirm(`Are you sure you want to delete ${subject.title}?`)) return;
      this.$store.dispatch('deleteSubject', {subject});
    },

    toggleExpanded() {
      this.expanded = !this.expanded;
    },

    startEditingTitle() {
      if (showActions) {
        this.newTitle = this.subject.title;
        this.editingTitle = true;
      }
    },
    cancelEditingTitle() {
      this.editingTitle = false;
    },
    finishEditingTitle() {
      const _this = this;
      const changes = { title: this.newTitle };
      this.$store.dispatch('updateSubject', { id: this.subject.id, changes }).then(() => {
        _this.editingTitle = false;
        _this.newTitle = '';
      });
    },
  },

    computed: {
    ...mapState([
      'currentUser',
    ]),
    chapters() {
      const chapters = _.where(this.$store.getters.allChapters, {subject_id: this.subject.id});
      return chapters;
    },
    showActions() {
      return this.currentUser.role !== 'student';
    },
  },

  data() {
    return {
      expanded: true,
      editingTitle: false,
      newTitle: '',
    }
  },

  directives: {
    onClickAway,
    focus: {
      // When the bound element is inserted into the DOM...
      inserted: function (el) {
        // Focus the element
        el.focus();
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.panel-heading {
  // disable select
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .expandButton {
    padding: 3px 7px;
    cursor: pointer;
  }

  .icon {
    color: #bababa;
  }
}

</style>



// WEBPACK FOOTER //
// SubjectShelfSubject.vue?6bcec9ad